import React from "react";
import { useObservable } from "micro-observables";
import { useI18n } from "@core/i18n/i18n";
import { useNavigate } from "@core/routing/use-navigate";
import { getStartedManager } from "@core/service-container";
import { analyticsService } from "@core/service-container";
import { AnalyticsCategory } from "@domain/analytics/analytics-types";
import ScheduleIcon from "@assets/icons/schedule.svg";
import { RoutesPath } from "@ui/navigation/routes";
import { OnboardingCard } from "@ui/pages/get-started/components/onboarding-card";
import { ArrowButton } from "@ui/pages/get-started/components/arrow-button";

interface ProgramsCardProps {
	className?: string;
}

export const ProgramsCard: React.FC<ProgramsCardProps> = ({ className }) => {
	const { format } = useI18n();
	const navigate = useNavigate();
	const programsStepStatus = useObservable(getStartedManager.programsStepStatus);

	return (
		<OnboardingCard
			className={className}
			status={programsStepStatus}
			icon={ScheduleIcon}
			mainHeadline={format("getStarted.programsCard.mainHeadline")}
			secondaryHeadline={format("getStarted.programsCard.secondaryHeadline")}
			description={format("getStarted.programsCard.description")}
			bottom={
				<ArrowButton
					label={format("getStarted.programsCard.ctaButton")}
					onClick={() => {
						analyticsService.trackEvent({
							category: AnalyticsCategory.GETSTARTED,
							action: "cardCTA",
							params: ["programs"],
						});
						navigate(RoutesPath.TemplateBuilder);
					}}
				/>
			}
		/>
	);
};
